import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    standalone: false
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  private scrollBtn: HTMLButtonElement | null = null;
  private scrollListener: (() => void) | null = null;
  private resizeListener: (() => void) | null = null;

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private doc: Document
  ) {}

  ngOnInit() {
    this.createScrollTopButton();
    this.scrollListener = this.renderer.listen('window', 'scroll', () => this.updateVisibility());
    this.resizeListener = this.renderer.listen('window', 'resize', () => this.updateVisibility());
    this.updateVisibility();
  }

  ngOnDestroy() {
    if (this.scrollListener) { this.scrollListener(); }
    if (this.resizeListener) { this.resizeListener(); }
    if (this.scrollBtn && this.scrollBtn.parentNode) {
      this.scrollBtn.parentNode.removeChild(this.scrollBtn);
    }
    this.scrollBtn = null;
  }

  private createScrollTopButton(): void {
    const btn = this.renderer.createElement('button') as HTMLButtonElement;
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Scroll to top');
    btn.title = 'Scroll to top';
    btn.innerHTML = `<i class='bx bx-up-arrow-alt' style='font-size:1.6rem'></i>`;

    // All styles inline so no ancestor CSS can interfere
    Object.assign(btn.style, {
      position: 'fixed',
      right: '20px',
      bottom: '20px',
      zIndex: '99999',
      width: '48px',
      height: '48px',
      borderRadius: '50%',
      border: 'none',
      display: 'none',           // hidden by default
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      color: '#ffffff',
      backgroundColor: '#00AAE6',
      boxShadow: '0 6px 18px rgba(0,0,0,0.35)',
      transition: 'background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease',
    });

    btn.addEventListener('mouseenter', () => {
      btn.style.backgroundColor = '#0095CC';
      btn.style.transform = 'translateY(-2px)';
      btn.style.boxShadow = '0 10px 24px rgba(0,0,0,0.45)';
    });
    btn.addEventListener('mouseleave', () => {
      btn.style.backgroundColor = '#00AAE6';
      btn.style.transform = '';
      btn.style.boxShadow = '0 6px 18px rgba(0,0,0,0.35)';
    });

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // Append directly to <body> — no ancestor can break fixed positioning
    this.doc.body.appendChild(btn);
    this.scrollBtn = btn;
  }

  private updateVisibility(): void {
    if (!this.scrollBtn) { return; }
    const scrollTop = window.pageYOffset || this.doc.documentElement.scrollTop || 0;
    this.scrollBtn.style.display = scrollTop > 300 ? 'inline-flex' : 'none';
  }
}
